import type { ImportContext } from './useContractImport';
import styles from './UploadContracts.module.scss';

export const ImportContextCard = ({ context }: { context: ImportContext }) => (
  <div className={styles.context} data-cy="contract-import-context">
    <strong>{context.fileName}</strong>
    <dl>
      <div>
        <dt>Contrato</dt>
        <dd>{context.contractKind}</dd>
      </div>
      <div>
        <dt>Inicio</dt>
        <dd>{context.startDate}</dd>
      </div>
      {context.endDate && (
        <div>
          <dt>Fin</dt>
          <dd>{context.endDate}</dd>
        </div>
      )}
    </dl>
  </div>
);
